import { jsx as p } from "react/jsx-runtime";
import { useMultiStyleConfig as a, useTheme as m, chakra as k } from "@chakra-ui/react";
const u = ({
  children: c,
  as: s,
  variant: e = "body",
  type: l = "primary",
  ...t
}) => {
  const y = !s && (e === "h1" || e === "h2" || e === "h3" || e === "h4") ? e : s, h = a("Typography", { variant: e }), r = m();
  let o;
  switch (l) {
    case "secondary":
      o = r.colors.gray[600];
      break;
    case "error":
      o = r.colors.red[500];
      break;
    case "link":
      o = r.colors.teal[500];
      break;
    case "primary":
    default:
      o = r.color;
      break;
  }
  return /* @__PURE__ */ p(k.p, { __css: h, color: o, as: y, ...t, children: c });
};
export {
  u as Typography
};
